import React from "react";
import { FiCheck } from "react-icons/fi";
import "./AboutChoose.css";
const FEATURES = [
  {
    title: "Eco‑Friendly Disposal",
    text: "We divert over 70% of items from landfills through recycling and donations, keeping your space—and the planet—clean.",
    color: "#62B64B",
  },
  {
    title: "Same‑Day & Scheduled Pickups",
    text: "Need it gone today? Or plan ahead—our 24/7 online booking fits any schedule, even last‑minute requests.",
    color: "#62B64B",
  },
  {
    title: "Upfront, Transparent Rates",
    text: "We do volume-based pricing with zero hidden fees to ensure that you never get a surprise bill.",
    color: "#62B64B",
  },
  {
    title: "Professional-Grade Equipment",
    text: "From heavy machinery to hand tools, our crew uses top‑of‑the‑line gear for fast, safe junk removal.",
    color: "#62B64B",
  },
  {
    title: "One‑Call Full Service",
    text: "Residential cleanouts , garage cleanouts, officecleanouts & construction debris we handle every job end‑to‑end with one call.",
    color: "#62B64B",
  },
  {
    title: "100% Satisfaction Guarantee",
    text: "If you’re not happy, neither are we. We’ll make it right—guaranteed—until your space is spotless.",
    color: "#62B64B",
  },
];


export default function AboutChoose() {
  return (
    <section className="about-choose">
      <div className="about-choose__container">
        <div className="about-choose__header">
          <h2 className="about-choose__heading">Why Choose Us?</h2>
          <p className="about-choose__subtitle">
            We go beyond basic junk removal to deliver exceptional service with real benefits
          </p>
        </div>

        <div className="about-choose__grid">
          {FEATURES.map((feature, index) => (
            <div className="feature-card" key={index}>
              <div 
                className="feature-icon-container"
                style={{ backgroundColor: `${feature.color}20` }}
              >
                <div 
                  className="feature-icon"
                  style={{ backgroundColor: feature.color }}
                >
                  <FiCheck size={24} color="#fff" />
                </div>
              </div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.text}</p>
              <div 
                className="feature-hover-indicator"
                style={{ backgroundColor: feature.color }}
              ></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}